module.exports = __webpack_public_path__ + "static/media/logo.c4d11ab3.svg";